import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ExpenseService } from '../../../../Services/Expenses/expense.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { ExpenseTypeService } from '../../../../Services/Expenses/expense-type.service';
import { CommonModule, NgIf } from '@angular/common';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-add-expense',
  imports: [RouterLink, ReactiveFormsModule, NgIf, CommonModule],
  templateUrl: './add-expense.component.html'
})
export class AddExpenseComponent {
  expenseForm!: FormGroup;
  editMode: boolean = false;
  listPath: string = '/expense';
  selectedFile: File | null = null;
  fileName: string = '';
  currentDocumentUrl: string | null = null;

  expenseAccounts: any[] = [];
  selectedFirmId!: number;

  constructor(
    private fb: FormBuilder,
    private expenseService: ExpenseService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService,
    private expenseTypeService: ExpenseTypeService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.initExpenseForm(null);

    this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      if (firm?.id) {
        this.selectedFirmId = firm.id;
        this.getExpenseAccounts();
        this.expenseForm.patchValue({
          exp_firm_id: firm.id
        });
      }
    });

    this.getIdForEditExpense();

    if (this.router.url.includes('rm-portal')) {
      this.listPath = '/rm-portal/expense';
    }

    this.expenseForm.patchValue({
      exp_date: this.getTodayDate()
    });
  }

  getExpenseAccounts() {
    if (!this.selectedFirmId) return;

    let params = new HttpParams().set('firm_id', this.selectedFirmId.toString());

    this.expenseTypeService.getExpenseTypes(params).subscribe((response: any) => {
      this.expenseAccounts = response.data || [];
    });
  }

  getIdForEditExpense() {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.editMode = true;

      this.expenseService.getExpense(id).subscribe((response: any) => {

        console.log('Full API Response:', response);

        const expense = response.data;

        this.expenseForm.patchValue({
          exp_date: expense.date,
          exp_type_id: expense.expense_type?.id,
          exp_amount: expense.amount,
          exp_firm_id: expense.firm?.id
        });

        this.currentDocumentUrl = expense.document;

      }, (error) => {
        console.log('API Error:', error);
      });
    }
  }

  onSubmit() {
    const formData = new FormData();
    Object.keys(this.expenseForm.value).forEach(key => {
      if (this.expenseForm.value[key] !== null && this.expenseForm.value[key] !== undefined) {
        formData.append(key, this.expenseForm.value[key]);
      }
    });

    if (this.selectedFile) {
      formData.append('document', this.selectedFile);
    }

    this.expenseService.createExpense(formData).subscribe((response: any) => {
      this.notificationService.showSuccess("Expense Added successfully", "success");
      this.onClear();
    })
  }

  updateExpense() {
    const id = this.route.snapshot.paramMap.get('id');

    const formData = new FormData();
    Object.keys(this.expenseForm.value).forEach(key => {
      if (this.expenseForm.value[key] !== null && this.expenseForm.value[key] !== undefined) {
        formData.append(key, this.expenseForm.value[key]);
      }
    });

    if (this.selectedFile) {
      formData.append('document', this.selectedFile);
    }

    // 🔥 Laravel Workaround: multipart/form-data doesn't work with PUT/PATCH
    // We send POST but spoof the method to PUT
    formData.append('_method', 'PUT');

    this.expenseService.updateExpense(id, formData).subscribe((response: any) => {
      this.notificationService.showSuccess("Expense Updated Successfully", "Success");
      this.router.navigate([this.listPath]);
    })
  }

  getTodayDate() {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  initExpenseForm(firmId: any) {
    this.expenseForm = this.fb.group({
      exp_date: [''],
      exp_type_id: [''],
      exp_amount: [''],
      exp_firm_id: [firmId]
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
    }
  }

  onClear() {
    this.expenseForm.reset({
      exp_date: this.getTodayDate()
    });
    this.selectedFile = null;
    this.fileName = '';
    this.currentDocumentUrl = null;
  }

  openDocument(url: string | null) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === 'Enter') {
      keyboardEvent.preventDefault();
      const target = keyboardEvent.target as HTMLElement;
      const form = target.closest('form');
      if (!form) return;
      const focusable = Array.from(
        form.querySelectorAll<HTMLElement>('input, select, textarea, button')
      ).filter(el => !el.hasAttribute('disabled') && el.tabIndex !== -1);
      const index = focusable.indexOf(target);
      if (index > -1 && index + 1 < focusable.length) {
        focusable[index + 1].focus();
      }
    }
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === 'Enter') {
      event.preventDefault();
      this.onSubmit();
    }
  }
}
